if ( typeof CollectionTabs !== 'function' ) {

  class CollectionTabsCustom extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      this.tabs = this.querySelectorAll('.collection-tabs_tab');
      this.grid = this.querySelector('[id^="product-grid-custom-"]');

      this.viewCollectionLink =
        this.querySelector('.section-heading__actions a');

      this.viewCollectionLink2 =
        this.querySelector('.js-view-collection-link');

      this.tabs.forEach(tab => {

        tab.addEventListener('click', e => {

          e.preventDefault();

          this.loadCollection(tab);

        });

      });

      // primeira coleção automática
      if (this.tabs.length > 0) {

        this.loadCollection(this.tabs[0]);

      } else {

        const panel = this.querySelector('.collection-tabs_panel');

        if (panel) {
          panel.classList.add('active');
          panel.removeAttribute('aria-hidden');
        }

      }

    }

    async loadCollection(tab) {

      const button = tab.querySelector('button');

      const panelId = button.dataset.panelId;
      const collectionHandle = button.dataset.collectionHandle;
      const collectionUrl = button.dataset.collectionUrl;

      const targetId =
        `collection-custom-${this.grid.dataset.sectionId}-${panelId}`;

      // tabs
      this.tabs.forEach(t => {

        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');

      });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      // links
      if (this.viewCollectionLink && collectionUrl) {
        this.viewCollectionLink.href = collectionUrl;
      }

      if (this.viewCollectionLink2 && collectionUrl) {
        this.viewCollectionLink2.href = collectionUrl;
      }

      // já existe
      const existingPanel =
        this.querySelector(`#${targetId}`);

      if (existingPanel) {

        this.querySelectorAll('.collection-tabs_panel')
          .forEach(panel => {

            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true');

          });

        existingPanel.classList.add('active');
        existingPanel.removeAttribute('aria-hidden');

        return;
      }

      this.grid.classList.add('is-loading');

      try {

        const response = await fetch(
          `${collectionUrl}?section_id=${this.grid.dataset.sectionId}`
        );

        const htmlText = await response.text();

        const parser = new DOMParser();

        const doc = parser.parseFromString(htmlText, 'text/html');

        const panel =
          doc.querySelector('.collection-tabs_panel');

        if (!panel) {

          console.error('Painel não encontrado');

          return;

        }

        // remove ativos antigos
        this.querySelectorAll('.collection-tabs_panel')
          .forEach(panel => {

            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true');

          });

        panel.id = targetId;

        panel.classList.add('active');

        panel.removeAttribute('aria-hidden');

        this.grid.appendChild(panel);

      } catch(error) {

        console.error(error);

      } finally {

        this.grid.classList.remove('is-loading');

      }

    }

  }

  customElements.define('collection-tabs-custom', CollectionTabsCustom);

}